module.exports = __webpack_public_path__ + "76a0c5e5b22c7b839bcc1033672154f8.glb";